import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import EastIcon from '@mui/icons-material/East';
import Bugsnag from '@bugsnag/js';
import colors from 'styles/colors';
import { auth, useAuthState } from 'api/services/firebase';
import { useEffect } from 'react';

const JobNotebookGeneralError = ({ error, onStart }) => {
  const navigate = useNavigate();
  const [user] = useAuthState(auth);
  const regex = /not enough funds/i;
  const notEnoughFunds = regex.test(error.response?.data?.errorMessage);

  useEffect(() => {
    Bugsnag.notify(new Error(error), (event) => {
      event.setUser(user.uid, user.email, user.displayName);
      event.addMetadata('jupyter_notebook', { notEnoughFunds });
    });
  }, []);

  let errorContent = (
    <Box>
      <Typography
        sx={{ color: colors.text.primary, paddingBottom: '15px', display: 'block' }}
        variant="h6"
      >
        Something went wrong. Please try again later.
      </Typography>
      <Box style={{ textAlign: 'center' }}>
        <Button variant="contained" type="primary" onClick={onStart}>
          Start the Notebook
        </Button>
      </Box>
    </Box>
  );

  if (notEnoughFunds) {
    errorContent = (
      <Box>
        <Typography
          sx={{ color: colors.text.primary, paddingBottom: '15px', display: 'block' }}
          variant="h6"
        >
          There are not enough funds.
        </Typography>
        <Box style={{ textAlign: 'center' }}>
          <Button
            variant="outlined"
            type="primary"
            onClick={() => navigate('/billing')}
            endIcon={<EastIcon color={colors.text.primary} />}
          >
            Proceed to Billings
          </Button>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      style={{
        height: 'calc(100% - 2px)',
        marginLeft: '3px',
        overflowX: 'hidden',
        overflowY: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {errorContent}
    </Box>
  );
};

export default JobNotebookGeneralError;
